import { generatePath } from 'react-router-dom';
import { APP_URLS } from '../../routes/urls';
import {
  ProfileIcon,
  FamilyIcon,
  EducationIcon,
  WorkIcon,
  AchievementIcon,
  HeartIcon,
  DocumentIcon,
  ApplicationIcon,
  SkillIcon,
  PasswordIcon,
} from '../../assets/icons';

export const getAllProfileUrls = (
  slug: string | undefined
): {
  section: 'Profile Overview' | 'Settings';
  urls: {
    path: string;
    label: string;
    Icon: React.FunctionComponent<
      React.SVGProps<SVGSVGElement> & {
        title?: string | undefined;
      }
    >;
  }[];
}[] => {
  const urlParams = { studentSlug: slug };
  return [
    {
      section: 'Profile Overview',
      urls: [
        {
          path: generatePath(APP_URLS.profile, urlParams),
          label: 'General Information',
          Icon: ProfileIcon,
        },
        {
          path: generatePath(APP_URLS.familyInfo, urlParams),
          label: 'Family Details',
          Icon: FamilyIcon,
        },
        {
          path: generatePath(APP_URLS.educationInfo, urlParams),
          label: 'Education',
          Icon: EducationIcon,
        },
        {
          path: generatePath(APP_URLS.achievementInfo, urlParams),
          label: 'Achievements',
          Icon: AchievementIcon,
        },
        {
          path: generatePath(APP_URLS.workInfo, urlParams),
          label: 'Work Experience',
          Icon: WorkIcon,
        },
        {
          path: generatePath(APP_URLS.wishlistInfo, urlParams),
          label: 'Wishlists',
          Icon: HeartIcon,
        },
        {
          path: generatePath(APP_URLS.documentInfo, urlParams),
          label: 'Documents',
          Icon: DocumentIcon,
        },
        {
          path: generatePath(APP_URLS.applicationInfo, urlParams),
          label: 'My Applications',
          Icon: ApplicationIcon,
        },
      ],
    },
    {
      section: 'Settings',
      urls: [
        {
          path: generatePath(APP_URLS.editProfile, urlParams),
          label: 'General Information',
          Icon: ProfileIcon,
        },
        {
          path: generatePath(APP_URLS.editFamilyInfo, urlParams),
          label: 'Family Details',
          Icon: FamilyIcon,
        },
        {
          path: generatePath(APP_URLS.editEducationInfo, urlParams),
          label: 'Education',
          Icon: EducationIcon,
        },
        {
          path: generatePath(APP_URLS.editAchievementInfo, urlParams),
          label: 'Achievements',
          Icon: AchievementIcon,
        },
        {
          path: generatePath(APP_URLS.editWorkInfo, urlParams),
          label: 'Work Experience',
          Icon: WorkIcon,
        },
        {
          path: generatePath(APP_URLS.editDocumentInfo, urlParams),
          label: 'Documents',
          Icon: DocumentIcon,
        },
        {
          path: generatePath(APP_URLS.editSkills, urlParams),
          label: 'Skills',
          Icon: SkillIcon,
        },
        {
          path: generatePath(APP_URLS.editPassword, urlParams),
          label: 'Reset Your Password',
          Icon: PasswordIcon,
        },
        {
          path: generatePath(APP_URLS.deleteAccount, urlParams),
          label: 'Delete Account',
          Icon: ProfileIcon,
        },
      ],
    },
  ];
};
